import * as React from 'react';

import {
  IconMapCar16,
  IconMapWalk16,
  IconMapMetroMsk16,
  IconMapMetroSam16,
  IconMapMetroNN16,
  IconMapMetroKzn16,
  IconMapMetroNovosib16,
  IconMapMetroEkb16,
  IconMapMetroSpb16,
  IIconProps,
} from '@cian/ui-kit-design-tokens/icons';

import { TTransportType, TUndergroundType } from '../../types/subway';

export const transportIconMap: Record<TTransportType, React.FC> = {
  walk: IconMapWalk16,
  transport: IconMapCar16,
};

export const metroIconMap: Record<TUndergroundType, React.FunctionComponent<IIconProps>> & {
  default: React.FunctionComponent<IIconProps>;
} = {
  spb: IconMapMetroSpb16,
  mow: IconMapMetroMsk16,
  ekb: IconMapMetroEkb16,
  kzn: IconMapMetroKzn16,
  nsk: IconMapMetroNovosib16,
  nn: IconMapMetroNN16,
  smr: IconMapMetroSam16,
  default: IconMapMetroMsk16,
};
